import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs';
import { menuItem, menuItems, partialUrlsMatch } from 'src/app/model/menu';
import { AI_STUDIO_VOICE_PERMISSION } from 'src/app/modules/ai-studio/utils/subscription-plan.util';
import { AiService } from 'src/app/services/ai/ai.service';
import { CommonService } from 'src/app/services/common/common.service';
import { UserSelectionService } from 'src/app/services/user-selection/user-selection.service';

@Component({
    selector: 'side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    standalone: false
})
export class SideMenuComponent {
  orgImageLoading: boolean = true;
  orgLogoUrl: string = '';
  orgName: string = '';
  avatar: string | ArrayBuffer;
  currentParent: string = 'quote';
  currentChild: string = 'cases';
  menuItems: menuItem[] = menuItems;
  caseId: string = '';
  partialUrlsMatch = partialUrlsMatch;
  @Input() sideMenuExpanded: boolean = true;
  @Output() sideMenuCollapse: EventEmitter<any> = new EventEmitter();
  showBackdrop: boolean = false;
  private automotiveServices: any;

  // ai-assistant
  public aiApiLoaded: boolean = false;
  public showAIAssistant: boolean = false;
  public agentAssociationId: string = '';

  public avatarUrl: string = 'assets/img/ai-chat-bot-new.png';
  public userDetail: any;
  public selectedOrgId: number;

  /**
   * constructor
   * @param router
   */
  constructor(private readonly cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly userSelectionService: UserSelectionService,
    private readonly aiService: AiService) {
    this.commonService.userProfileData.subscribe((res: any) => {
      this.userDetail = res?.data;
      this.orgLogoUrl = res?.data?.organizationDetail?.thumbnailBlobUrl ?? res?.data.organizationDetail?.logoUrl;

      this.orgName = res?.data.organizationDetail?.name;

      const selectedOrg = this.userSelectionService.getSelectedOrg();
      if (selectedOrg) {
        this.orgName = selectedOrg.name;
        this.orgLogoUrl = selectedOrg.thumbnailBlobUrl || selectedOrg.logoUrl;
      }
      this.selectedOrgId = selectedOrg?.id || this.userDetail?.organizationDetail?.id;
      if (!this.orgLogoUrl) {
        this.orgImageLoading = false;
      }
      const automotiveServices = res?.data?.userPermission?.automotiveServices;
      this.automotiveServices = automotiveServices;
      const currentUserRole = res?.data?.roleDetail;
      const isRepairLite = currentUserRole?.some(r => r.automotiveServiceName === 'Addenda Repair' && r.labelName === 'Addenda Repair Lite');
      const orgPackages = res?.data?.userPermission?.orgPackages ?? [];
      this.menuItems.forEach((menuItem: menuItem) => {
        let automotiveService;
        if (menuItem?.automotiveService) {
          if (menuItem.name === 'settings') {
            if (Array.isArray(menuItem.automotiveService)) {
              const roleService = automotiveServices?.find(
                x =>
                  menuItem.automotiveService.includes(x.automotiveServiceName) &&
                  (x.roleName.toLowerCase() === 'bodyshop manager' ||
                    x.roleName.toLowerCase() === 'claim manager' ||
                    x.roleName.toLowerCase() === 'quote case manager' ||
                    x.roleName.toLowerCase() === 'inventory manager' ||
                    x.roleName.toLowerCase() === 'supplier' ||
                    x.roleName.toLowerCase() === 'buyer' ||
                    x.roleName.toLowerCase() === 'auto admin' ||
                    x.roleName.toLowerCase() === 'b2b admin')
              );
              const userPermissionService = automotiveServices?.find(x => this.checkUserLevelPermission(menuItem.userLevelPermission, x));
              automotiveService = roleService || userPermissionService;
            } else {
              const roleService = automotiveServices?.find(
                x =>
                  x.automotiveServiceName === menuItem.automotiveService &&
                  (x.roleName.toLowerCase() === 'bodyshop manager' ||
                    x.roleName.toLowerCase() === 'claim manager' ||
                    x.roleName.toLowerCase() === 'quote case manager' ||
                    x.roleName.toLowerCase() === 'inventory manager' ||
                    x.roleName.toLowerCase() === 'supplier' ||
                    x.roleName.toLowerCase() === 'buyer' ||
                    x.roleName.toLowerCase() === 'auto admin' ||
                    x.roleName.toLowerCase() === 'b2b admin')
              );
              const userPermissionService = automotiveServices?.find(x => this.checkUserLevelPermission(menuItem.userLevelPermission, x));
              automotiveService = roleService || userPermissionService;
            }

            //for now allow any thing for above roles
            // if (!automotiveService) {
            //   // for now only for addenda auto or any services having addenda auto
            //   if (Array.isArray(menuItem.automotiveService) && menuItem.automotiveService.includes('Addenda Auto')) {
            //     automotiveService = automotiveServices?.find(x => menuItem.automotiveService.includes(x.automotiveServiceName));
            //   } else if (menuItem.automotiveService == 'Addenda Auto') {
            //     automotiveService = automotiveServices?.find(x => x.automotiveServiceName === menuItem.automotiveService);
            //   }

            //   if (automotiveService) {
            //     const permissionList = [ ...new Set(automotiveServices?.flatMap(item => item.permissions)) ];
            //     if (!permissionList?.some((x: any) => menuItem.userLevelPermission?.includes(x.permissionName))) {
            //       automotiveService = undefined;
            //     }
            //   }
            // }
            const noPermissionRoles = [ 'technician', 'driver', 'service desk', 'service advisor' ];
            if (automotiveServices?.some(x => noPermissionRoles.includes(x.roleName.toLowerCase()))) {
              automotiveService = null;
            }
          } else {
            if (Array.isArray(menuItem.automotiveService)) {
              automotiveService = automotiveServices?.find(x => menuItem.automotiveService.includes(x.automotiveServiceName));
            } else {
              automotiveService = automotiveServices?.find(x => x.automotiveServiceName === menuItem.automotiveService);
            }
          }
          menuItem.permission = !!automotiveService;
          if (automotiveService && isRepairLite) {
            this.handleRepairPermissions(menuItem, automotiveService.permissions);
          }
        }
        if (automotiveService) {
          if (Array.isArray(menuItem.automotiveService) && menuItem.childMenu) {
            menuItem.childMenu?.forEach((x) => {
              const autoService = automotiveServices?.find(
                service =>
                  x.automotiveService?.includes(service.automotiveServiceName) &&
                  (service.roleName.toLowerCase() === 'bodyshop manager' ||
                    service.roleName.toLowerCase() === 'claim manager' ||
                    service.roleName.toLowerCase() === 'quote case manager' ||
                    service.roleName.toLowerCase() === 'inventory manager' ||
                    service.roleName.toLowerCase() === 'supplier' ||
                    service.roleName.toLowerCase() === 'auto admin' ||
                    service.roleName.toLowerCase() === 'admin' ||
                    service.roleName.toLowerCase() === 'b2b admin')
              );
              if (autoService) {
                x.permission = true;
              } else {
                const permission = this.checkUserLevelPermissions(x.userLevelPermission, automotiveServices);
                const hasMenuItemService = automotiveServices?.some(y => x.automotiveService?.includes(y.automotiveServiceName));
                x.permission = (hasMenuItemService && permission) ?? false;
              }
            });
          }
          if (
            automotiveService.automotiveServiceName?.toLowerCase() === 'addenda claims' ||
            automotiveService.automotiveServiceName?.toLowerCase() === 'claim surveyor'
          ) {
            if (menuItem.name === 'repairer_view' || menuItem.name === 'claim') {
              menuItem.permission = this.getMenuPermission(orgPackages, automotiveService, menuItem);
              if (menuItem.permission) {
                let defaultChild = null;
                for (const child of menuItem.childMenu) {

                  if (child.automotiveService) {
                    if (Array.isArray(child.automotiveService)) {
                      child.permission = child.automotiveService.some(x => this.automotiveServices?.some(y => y.automotiveServiceName === x));
                    } else {
                      child.permission = this.automotiveServices?.some(x => x.automotiveServiceName === child.automotiveService);
                    }
                  }
                  if (child.service) {
                    child.permission = this.getCurrentPermission(orgPackages, automotiveService, child);
                    if (child.permission && !defaultChild) {
                      menuItem.defaultChildMenu = child.name;
                      menuItem.url = child.url;
                      defaultChild = child.name;
                    }
                  }
                }
              }
            }
          }
          if (
            automotiveService.automotiveServiceName?.toLowerCase() === 'quote assessment' ||
            automotiveService.automotiveServiceName?.toLowerCase() === 'addenda inventory'
          ) {
            for (const child of menuItem.childMenu) {
              let isAutoMotiveService = false;
              if (Array.isArray(child.automotiveService)) {
                if (child.automotiveService?.includes(automotiveService.automotiveServiceName)) {
                  isAutoMotiveService = true;
                }
              } else if (child.automotiveService?.toLowerCase() == automotiveService.automotiveServiceName?.toLowerCase()) {
                isAutoMotiveService = true;
              }
              if (child.userLevelPermission && isAutoMotiveService) {
                child.permission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
              }
            }
          }
          if (automotiveService.roleName.toLowerCase() === 'service desk') {
            menuItem.childMenu?.map(x => (x.permission = false));
            const serviceDeskMenu = menuItem.childMenu?.filter(x => x.permissionName === 'lounge' || x.permissionName === 'workflow.lounge');
            if (serviceDeskMenu) {
              serviceDeskMenu.map(x => (x.permission = true));
            }
          }

          if (automotiveService.roleName.toLowerCase() === 'technician') {
            const serviceDeskMenu = menuItem.childMenu?.find(x => x.permissionName === 'customers');
            if (serviceDeskMenu) {
              serviceDeskMenu.permission = false;
            }
          }

          if (automotiveService.roleName.toLowerCase() === 'driver') {
            menuItem.childMenu?.map(x => (x.permission = false));
            const serviceDeskMenu = menuItem.childMenu?.find(x => x.permissionName === 'outbound');
            if (serviceDeskMenu) {
              serviceDeskMenu.permission = true;
            }
          }

          menuItem.childMenu?.forEach((child: menuItem) => {
            if (child?.permissionName === 'technician.calendar.view') {
              child.permission = automotiveService.permissions.some(x => x.permissionName === child.permissionName);
            }
          });
          if (menuItem.name === 'settings') {
            menuItem.childMenu?.forEach((child: menuItem) => {
              if (
                child?.name === 'estimate' &&
                (automotiveService.automotiveServiceName?.toLowerCase() === 'addenda repair' ||
                  automotiveService.automotiveServiceName?.toLowerCase() === 'carheal quote')
              ) {
                const repairPackage = orgPackages?.find(el => el.automotiveServiceName === 'Repair Estimate');
                const repairPermission = repairPackage?.permissions?.find(
                  p => p.permissionName === 'xa.repair.estimate' || p.permissionName === 'audatex.estimate'
                );
                const AIPackage = orgPackages?.find(el => el.automotiveServiceName === 'Artificial Intelligence Estimation');
                const AIPermission = AIPackage?.permissions?.find(p => p.permissionName === 'ai.estimation');
                child.permission = repairPermission !== undefined || AIPermission !== undefined;
              }

              let isAutoMotiveService = false;
              if (Array.isArray(child.automotiveService)) {
                if (child.automotiveService?.includes(automotiveService.automotiveServiceName)) {
                  isAutoMotiveService = true;
                }
              } else if (child.automotiveService?.toLowerCase() == automotiveService.automotiveServiceName?.toLowerCase()) {
                isAutoMotiveService = true;
              }

              if (child?.permissionName === 'sales') {
                const childAutomotiveService = automotiveServices?.find(
                  x =>
                    child.automotiveService === x.automotiveServiceName &&
                    (x.roleName.toLowerCase() === 'inventory manager' || x.roleName.toLowerCase() === 'supplier')
                );
                if (childAutomotiveService) {
                  child.permission = true;
                } else {
                  child.permission = false;
                }
              }

              if (child.userLevelPermission && isAutoMotiveService) {
                child.permission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
              }

              if (child?.name === 'manage_user' && automotiveServices?.find(x => child?.automotiveService.includes(x.automotiveServiceName))) {
                const hasUserManagementPermission = orgPackages?.some(el => el.automotiveServiceName === 'User Management');
                //check user level permission
                const userLevelPermission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                child.permission = hasUserManagementPermission && userLevelPermission;
              } else {
                //for now keep it as it is, the highest permissions are given access to remaining settings
                // if (child?.userLevelPermission?.length > 0) {
                //   child.permission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                // } else {
                //   child.permission = false;
                // }
              }
            });
          }

          if (menuItem.name === 'crm') {
            menuItem.permission = false;
            if (
              automotiveService.roleName.toLowerCase() === 'bodyshop manager' ||
              automotiveService.roleName.toLowerCase() === 'service advisor' ||
              automotiveService.roleName.toLowerCase() === 'auto admin'
            ) {
              const hasCRMPermission = orgPackages?.some(el => el.automotiveServiceName === 'Customer Management');
              menuItem.permission = hasCRMPermission;
            } else {
              menuItem.permission = orgPackages?.some(el => el.automotiveServiceName === 'Customer Management');
              //TODO Default Child

              if (menuItem.permission) {
                //let defaultChild = null;
                for (const child of menuItem.childMenu) {
                  if (child.service) {
                    if (child?.userLevelPermission?.length > 0) {
                      child.permission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                    } else {
                      child.permission = false;
                    }
                  }
                }
              }
            }
          }

          if (menuItem.name === 'catalog_management') {
            if (automotiveService.roleName.toLowerCase() === 'auto admin') {
              menuItem.permission = true;
            } else {
              if (menuItem.permission) {
                //let defaultChild = null;
                for (const child of menuItem.childMenu) {
                  if (child.service) {
                    if (child?.userLevelPermission?.length > 0) {
                      child.permission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                    } else {
                      child.permission = false;
                    }
                  } else {
                    child.permission = true;
                  }
                }
              }
            }
          }

          if (menuItem.name === 'content_management') {
            if (automotiveService.roleName.toLowerCase() === 'auto admin') {
              menuItem.permission = true;
            } else {
              menuItem.permission = false;
            }
          }

          if (menuItem.name === 'bookings') {
            if (menuItem.permission) {
              const permissionList = [ ...new Set(automotiveServices?.flatMap(item => item.permissions)) ];
              menuItem.permission = permissionList?.some((x: any) => menuItem.userLevelPermission?.includes(x.permissionName));
            }
          }

          if (menuItem.name === 'sales') {
            if (this.commonService.hasSalesPermission()) {
              const userLevelPermission = this.checkUserLevelPermissions(menuItem.userLevelPermission, automotiveServices);
              menuItem.permission = userLevelPermission;
              menuItem.childMenu?.forEach((child: menuItem) => {
                const childUserLevelPermission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                child.permission = childUserLevelPermission;
              });
            } else {
              menuItem.permission = false;
            }
          }

          if (menuItem.name === 'inventory_management') {
            const userLevelPermission = this.checkUserLevelPermissions(menuItem.userLevelPermission, automotiveServices);
            menuItem.permission = userLevelPermission;
            menuItem.childMenu?.forEach((child: menuItem) => {
              const childUserLevelPermission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
              child.permission = childUserLevelPermission;
            });
          }

          if (menuItem.name === 'procurement') {
            if (this.commonService.hasPartsProcurementPermission()) {
              const userLevelPermission = this.checkUserLevelPermissions(menuItem.userLevelPermission, automotiveServices);
              menuItem.permission = userLevelPermission;
              menuItem.childMenu?.forEach((child: menuItem) => {
                const childUserLevelPermission = this.checkUserLevelPermissions(child.userLevelPermission, automotiveServices);
                child.permission = childUserLevelPermission;
              });
            } else {
              menuItem.permission = false;
            }
          }

          if (menuItem.name === 'employee_management') {
            menuItem.permission = false;
            if (
              automotiveService.roleName.toLowerCase() === 'bodyshop manager' ||
              automotiveService.roleName.toLowerCase() === 'auto admin' ||
              automotiveService.roleName.toLowerCase() === 'admin'
            ) {
              menuItem.permission = true;
            }
          }

          if (menuItem.name === 'accounting') {
            //menuItem.permission = false;
            //if ([ 'b2b admin', 'finance admin', 'finance manager', 'accountant' ].includes(automotiveService.roleName.toLowerCase())) {
            const accountingService = automotiveServices.find(q => q.automotiveServiceName.toLowerCase() === 'accounting');
            if (accountingService) {
              menuItem.permission = true;
            } else {
              menuItem.permission = false;
            }
            menuItem.childMenu?.forEach((child: any) => {
              if (child?.userLevelPermission?.length) {
                child.permission = this.checkUserLevelPermission(child.userLevelPermission, automotiveService);
              } else {
                child.permission = true;
              }
            });
            //}
          }

          if (menuItem.name === 'ai_studio') {
            const hasAiStudioPermission = orgPackages?.some(el => el.automotiveServiceName === 'AI Studio');
            if (hasAiStudioPermission) {
              menuItem.permission = true;

              if (
                automotiveService.automotiveServiceName?.toLowerCase() === 'addenda auto' &&
                automotiveService.roleName?.toLowerCase() === 'auto admin'
              ) {
                menuItem.permission = true;
                menuItem.childMenu?.forEach((child: menuItem) => {
                  if (child.name === 'ai_studio_plans_billing') {
                    child.permission = this.checkUserLevelPermissions(
                      child.userLevelPermission ?? [ 'ai.studio.agent.subscription' ],
                      automotiveServices
                    );
                  } else if (child.userLevelPermission?.includes(AI_STUDIO_VOICE_PERMISSION)) {
                    child.permission = this.checkUserLevelPermissions(
                      child.userLevelPermission,
                      automotiveServices
                    );
                  } else {
                    child.permission = true;
                  }
                });
              } else {
                const allPermissions = [
                  ...new Set(automotiveServices?.flatMap(item => item.permissions.map(permission => permission.permissionName)))
                ];
                const aiStudioMenus = this.menuItems?.find(x => x.name === 'ai_studio')?.childMenu;
                if (aiStudioMenus && aiStudioMenus?.length > 0 && allPermissions && allPermissions?.length > 0) {
                  let hasAnyChildPermission: boolean = false;
                  aiStudioMenus.forEach((menu: menuItem) => {
                    if (Array.isArray(menu.userLevelPermission) && menu.userLevelPermission?.length > 0) {
                      menu.permission = allPermissions?.some(x => x == menu.userLevelPermission[0]);
                      if (menu.permission) {
                        hasAnyChildPermission = true;
                      }
                    }
                  });

                  if (!hasAnyChildPermission) {
                    menuItem.permission = false;
                  }
                }
              }
            } else {
              menuItem.permission = false;
            }
          }

          if (menuItem.childMenu?.length > 0) {
            const childWithPermission = menuItem.childMenu?.find(item => item.permission);
            if (childWithPermission) {
              menuItem.defaultChildMenu = childWithPermission.name;
              menuItem.url = childWithPermission.url;
              if (menuItem.title !== childWithPermission.title) {
                menuItem.title = childWithPermission.title;
              }
            } else {
              menuItem.permission = false;
            }
          }
        }
      });
      const permissionList = automotiveServices?.find(x => x.automotiveServiceName.toLowerCase() === 'carheal quote')?.permissions;
      const quoteMenus = this.menuItems?.find(x => x.name === 'quote')?.childMenu;
      if (quoteMenus && quoteMenus?.length > 0 && permissionList && permissionList?.length > 0) {
        quoteMenus.forEach((menu: menuItem) => {
          menu.permission = this.commonService.hasPermission(menu.permissionName, permissionList);
        });
      }

      const repairPermissionList = automotiveServices?.find(x => x.automotiveServiceName.toLowerCase() === 'addenda repair')?.permissions;
      const repairMenus = this.menuItems?.find(x => x.name === 'repair')?.childMenu;
      if (repairMenus?.length > 0 && repairPermissionList?.length > 0) {
        repairMenus.forEach((menu: menuItem) => {
          if (
            menu.name == 'technician_calendar' &&
            !automotiveServices?.find(automotiveService => automotiveService?.roleName.toLowerCase() === 'technician')
          ) {
            menu.permission = this.commonService.checkOrgPackagesPermission(orgPackages, 'technician calendar', 'technician.calendar');
          } else {
            menu.permission = this.commonService.hasPermission(menu.permissionName, repairPermissionList);
          }
        });
      }
      const homeMenuService = automotiveServices?.some(
        x => x.automotiveServiceName === 'Addenda Auto' || x.automotiveServiceName === 'Addenda Repair' || x.automotiveServiceName === 'Carheal Quote'
      );
      const allPermissions = [ ...new Set(automotiveServices?.flatMap(item => item.permissions.map(permission => permission.permissionName))) ];
      if (homeMenuService) {
        const home = this.menuItems?.find(x => x.name === 'home');
        if (home) {
          //const allPermissions = [ ...new Set(automotiveServices?.flatMap(item => item.permissions.map(permission => permission.permissionName))) ];
          const dashboardPermission = allPermissions.includes(home.permissionName);
          home.permission = dashboardPermission;
          const repairDashBoard = home.childMenu.find(x => x.url === '/home/dashboard/general' && x.permission === true);
          if (repairDashBoard) {
            const hasDashboardFeaturePackage = orgPackages
              ?.find(x => x.automotiveServiceName.toLowerCase() === 'analytics')
              ?.permissions?.some(x => x.permissionName?.toLowerCase() === 'dashboard');
            repairDashBoard.permission = hasDashboardFeaturePackage;
            home.permission = home.childMenu.some(x => x.permission === true);
          }
        }
      }

      const hasAgentChatPermission = allPermissions.includes('ai.studio.agent.chat');
      if (hasAgentChatPermission) {
        const agentDetails = res?.data?.agentDetails?.agents;
        const defaultAgent = agentDetails?.find(q => q.isDefault == true);

        if (defaultAgent) {
          this.agentAssociationId = defaultAgent.associationGuid;
          this.getAgentDetail();
          this.recreateAiAssistant();
        } else {
          this.agentAssociationId = '';
          this.showAIAssistant = false;
        }
      }

      if (this.menuItems.find(x => x.name === 'hrm').permission) {
        this.menuItems.find(x => x.name === 'employee_management').permission = false;

        const hrmsPermissionList = automotiveServices?.find(x => x.automotiveServiceName === 'HRMS')?.permissions;
        const hrmsMenu = this.menuItems?.find(x => x.name === 'hrm')?.childMenu;
        if (hrmsMenu && hrmsMenu?.length > 0 && hrmsPermissionList && hrmsPermissionList?.length > 0) {
          hrmsMenu.forEach((menu: menuItem) => {
            if (menu.permissionName) {
              menu.permission = this.commonService.hasPermission(menu.permissionName, hrmsPermissionList);
            }
            menu.childMenu?.forEach((child: menuItem) => {
              if (child.permissionName) {
                child.permission = this.commonService.hasPermission(child.permissionName, hrmsPermissionList);
              }
            });
          });
        }
      }
        this.cdr.markForCheck();
});

    this.commonService.applicationFeatureData.subscribe({
      next: (resp) => {
        if (resp) {
          const services = resp?.data[0]?.services || [];
          const fnolMainMenu = this.menuItems?.find(x => x.name?.toLowerCase() === 'fnol');
          const fnolMenus = fnolMainMenu?.childMenu;
          const fnolFileClaimList = fnolMenus.find(x => x.name === 'claim_transactions');
          const fnolFileNewClaim = fnolMenus.find(x => x.name === 'file_claim');
          const fnolService = services.find(x => x.serviceName?.toLowerCase() === 'fnol');
          if (!fnolService) {
            fnolFileNewClaim.permission = false;
            fnolFileClaimList.permission = false;
            fnolMainMenu.permission = false;
            return;
          }

          const fileClaimFeature = fnolService.features.find(x => x.featureName === 'file.claim');
          const listClaimFeature = fnolService.features.find(x => x.featureName === 'claim.transactions');

          if (fileClaimFeature) {
            fnolFileNewClaim.title = fileClaimFeature.title;
            fnolFileNewClaim.permission = fileClaimFeature.isActive;
          } else {
            fnolFileNewClaim.permission = false;
          }

          if (listClaimFeature) {
            fnolFileClaimList.title = listClaimFeature.title;
            fnolFileClaimList.permission = listClaimFeature.isActive;
          } else {
            fnolFileClaimList.permission = false;
          }

          if (!fnolFileClaimList.permission === false && fnolFileNewClaim.permission === false) {
            fnolMainMenu.permission = false;
          }
        }
      }
    });

    this.commonService.caseId.subscribe((id) => {
      if (id) {
        this.caseId = id;
      }
        this.cdr.markForCheck();
});

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      let url = event.url == '/' ? '/home' : event.url;

      if (url === '/accessDenied' || url === '/notFound') {
        return;
      }
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.lastIndexOf('?'));
      }
      if (url === '/profile') {
        this.currentParent = null;
        this.currentChild = '';
        return;
      }

      if (url === '/repair/check-in-out-logs') {
        this.currentParent = 'repair';
        this.currentChild = null;
        return;
      }

      const exactMatch = this.partialUrlsMatch.filter(item => item.partialUrl === url);
      const partialCandidates = this.partialUrlsMatch.filter(item => url.indexOf(item.partialUrl) !== -1);
      // Prefer the longest partialUrl so `/accounting/receivable/sales-invoices/:guid` matches sales-invoices, not `/accounting`.
      const partialUrlMatchData =
        exactMatch.length > 0 ? exactMatch : [ ...partialCandidates ].sort((a, b) => b.partialUrl.length - a.partialUrl.length);
      if (partialUrlMatchData.length > 0 && partialUrlMatchData[0].currentParent) {
        this.currentParent = partialUrlMatchData[0].currentParent;
        this.currentChild = partialUrlMatchData[0].currentChild;
        return;
      }
      const menuItem = this.menuItems.find(x => x.url === url);
      if (menuItem) {
        this.currentParent = menuItem?.parent ?? menuItem?.name;
        this.currentChild = menuItem?.defaultChildMenu ?? menuItem?.name;
      } else {
        const menuItem = this.menuItems.find((obj) => {
          return obj.childMenu?.some((child: menuItem) => child.url === url);
        });

        if (menuItem) {
          const childMenuItem = menuItem.childMenu?.find(x => x.url === url);
          if (childMenuItem) {
            this.currentParent = menuItem?.parent ?? menuItem?.name;
            this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
          } else {
            if (url.toLowerCase().indexOf('/quote/case/') != -1) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/quote/case/0');
              this.currentParent = menuItem?.parent ?? menuItem?.name;
              this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
            } else if (url.toLowerCase().indexOf('/repair/booking/') != -1) {
              const menuItem = this.menuItems.find(x => x.name === 'repair');
              this.currentParent = menuItem?.parent ?? menuItem?.name;
              this.currentChild = menuItem?.defaultChildMenu ?? menuItem?.name;
            } else if (url.toLowerCase().indexOf('/case/detail/') != -1) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/case/detail/0');
              this.currentParent = menuItem?.parent ?? menuItem?.name;
              this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
            } else {
              this.currentParent = 'home';
              this.currentChild = 'dashboard';
            }
          }
        } else {
          if (url.toLowerCase().indexOf('/quote/case/') != -1) {
            const menuItem = this.menuItems.find((obj) => {
              return obj.childMenu?.some((child: menuItem) => child.url === '/quote/case/0');
            });
            if (menuItem) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/quote/case/0');
              if (childMenuItem) {
                this.currentParent = menuItem?.parent ?? menuItem?.name;
                this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
              }
            }
          } else if (url.toLowerCase().indexOf('/repair/booking/') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'repair');
            this.currentParent = menuItem?.parent ?? menuItem?.name;
            this.currentChild = menuItem?.defaultChildMenu ?? menuItem?.name;
          } else if (url.toLowerCase().indexOf('/repair/customers/') != -1) {
            const menuItem = this.menuItems.find((obj) => {
              return obj.childMenu?.some((child: menuItem) => child.url === '/repair/customers/company');
            });
            const childMenuItem = menuItem.childMenu?.find(x => x.url === '/repair/customers/company');
            this.currentParent = menuItem?.parent ?? menuItem?.name;
            this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
          } else if (
            url === '/settings/repair-type' ||
            url === '/settings/jobs-tasks' ||
            url === '/settings/scheduling' ||
            url === '/settings/calendar' ||
            url === '/settings/target' ||
            url === '/settings/repair-cost-setting'
          ) {
            const menuItem = this.menuItems.find(x => x.url === '/settings');
            this.currentParent = menuItem?.parent ?? menuItem?.name;
            this.currentChild = menuItem?.defaultChildMenu ?? menuItem?.name;
          } else if (
            url === '/inventory/settings/taxes' ||
            url === '/inventory/settings/profit' ||
            url === '/inventory/settings/manufacturers' ||
            url === '/inventory/settings/suppliers'
          ) {
            // || url === '/settings/permission' ||
            // url === '/settings/notification'
            const menuItem = this.menuItems.find(x => x.url === '/inventory/settings');
            this.currentParent = menuItem?.parent ?? menuItem?.name;
            this.currentChild = menuItem?.defaultChildMenu ?? menuItem?.name;
          } else if (
            url.toLowerCase().indexOf('/claim/claim-detail/') != -1 ||
            url.toLowerCase().indexOf('/claim/estimate') != -1 ||
            url.toLowerCase().indexOf('/claim/claim-detail-v2/') != -1 ||
            url.toLowerCase().indexOf('/claim/fnol-details/') != -1 ||
            url.toLowerCase().indexOf('/claim/claim-edit/') != -1
          ) {
            const menuItem = this.menuItems.find(x => x.name === 'claim');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'my_claim');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/claim/garages/') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'claim');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'garages');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/claim/workflow/') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'claim');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'workflow');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/claim/outbound/') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'claim');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'outbound');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (
            url.toLowerCase().indexOf('claim/customer-satisfaction') != -1 ||
            url.toLowerCase().indexOf('claim/garages-dashboard') != -1 ||
            url.toLowerCase().indexOf('claim/sla') != -1
          ) {
            const menuItem = this.menuItems.find(x => x.name === 'claim');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'claim_dashboard');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/claimsetting') != -1) {
            const menuItem = this.menuItems.find(x => x.url === '/claimSetting');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'garages');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('repairer-view/dashboard/customers') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'repairer_view');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'repair_dashboard');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/dashboard') != -1) {
            const menuItem = this.menuItems.find(x => x.url === '/home' || '/home/dashboard/general');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'dashboard');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('repair/technician-calendar') != -1) {
            // By name: the permission pass replaces the parent's url with its first permitted child's url.
            const menuItem = this.menuItems.find(x => x.name === 'repair');
            const childMenuItem = menuItem?.childMenu?.find(x => x.name === 'technician_calendar');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else if (url.toLowerCase().indexOf('/case/detail/') != -1) {
            const menuItem = this.menuItems.find((obj) => {
              return obj.childMenu?.some((child: menuItem) => child.url === '/case/detail/0');
            });
            if (menuItem) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/case/detail/0');
              if (childMenuItem) {
                this.currentParent = menuItem?.parent ?? menuItem?.name;
                this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
              }
            }
          } else if (url.toLowerCase().indexOf('/settings/partners/') != -1) {
            const menuItem = this.menuItems.find(x => x.url === '/settings');
            if (menuItem) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/settings/partners');
              if (childMenuItem) {
                this.currentParent = menuItem?.parent ?? menuItem?.name;
                this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
              }
            }
          } else if (url === '/settings/estimate/tax' || url === '/settings/estimate/invoice' || url === '/settings/estimate/estimate') {
            const menuItem = this.menuItems.find(x => x.url === '/settings');
            if (menuItem) {
              const childMenuItem = menuItem.childMenu?.find(x => x.url === '/settings/estimate/tax');
              if (childMenuItem) {
                this.currentParent = menuItem?.parent ?? menuItem?.name;
                this.currentChild = childMenuItem.name ?? menuItem?.defaultChildMenu;
              }
            }
          } else if (url.toLowerCase().indexOf('/settings/service-configuration/category/') != -1) {
            const menuItem = this.menuItems.find(x => x.name === 'settings');
            const childMenuItem = menuItem.childMenu?.find(x => x.name === 'service_config');
            this.currentParent = childMenuItem?.parent ?? childMenuItem?.name;
            this.currentChild = childMenuItem?.name;
          } else {
            this.currentParent = 'home';
            this.currentChild = 'dashboard';
          }
        }
      }
        this.cdr.markForCheck();
});

    this.breakpointObserver.observe([ '(max-width: 576px)' ]).subscribe((result: BreakpointState) => {
      if (result.matches) {
        this.showBackdrop = true;
      } else {
        this.showBackdrop = false;
      }
        this.cdr.markForCheck();
});
  }

  /**
   * handle repair permissions
   */
  handleRepairPermissions(menu: menuItem, permissionList: any[]): void {
    const permissions = menu.childMenu?.map((m) => {
      return m.permissionName;
    });
    if (this.commonService.containsPermission(permissions, permissionList)) {
      menu.permission = true;
      menu.childMenu?.forEach((c) => {
        if (this.commonService.hasPermission(c.permissionName, permissionList)) {
          c.permission = true;
        } else {
          c.permission = false;
        }
      });
    } else {
      menu.permission = false;
    }
  }

  /**
   * navigate to menus
   * @param item
   */
  public navigate(item: menuItem): void {
    this.currentParent = item.parent ?? item.name;
    this.currentChild = item.defaultChildMenu ?? item.name;
    this.commonService.closeSearch.next(true);
    if (item.url === '/quote/case/0' && location.href.indexOf('case/') !== -1) {
      if (this.caseId === '0') {
        return;
      }
      this.router.navigateByUrl('/quote/case/0/refresh', { skipLocationChange: true }).then(() => {
        this.router.navigate([ item.url ]);
      });
    } else if (item.url === '/settings') {
      const hasRepairPermission = this.automotiveServices?.find(x => x.automotiveServiceName === 'Addenda Repair');
      const hasQuotePermission = this.automotiveServices?.find(x => x.automotiveServiceName === 'Carheal Quote');
      if (hasRepairPermission) {
        this.router.navigate([ item.url ]);
      } else if (hasQuotePermission) {
        this.router.navigate([ '/settings/estimate/tax' ]);
      }
    } else if (item.url === '/ai-studio/playground') {
      this.router.navigate([ item.url ], {
        queryParams: { fromPlayground: 'true' }
      });
    } else {
      this.router.navigate([ item.url ]);
    }
  }

  /**
   * get current permission
   * @param res
   * @param route
   * @returns
   */
  getCurrentPermission(orgPackages: any, automotiveServices: any, childMenuItem: any): boolean {
    const service = orgPackages?.find((orgPackage: any) => {
      return orgPackage.automotiveServiceName?.toLowerCase() === childMenuItem?.service?.toLowerCase();
    });

    // check if main automotive service (not addenda claim), here it is more like repair-view,my-claim,  is available
    if (service) {
      // check the permission within that automotive service
      if (service.permissions?.find(q => childMenuItem?.permissionName.toLowerCase() == q.permissionName.toLowerCase())) {
        if ((childMenuItem.name === 'workflow' || childMenuItem.name === 'outbound') && childMenuItem.parent === 'repairer_view') {
          const myClaimPackage = orgPackages?.find(x => x.automotiveServiceName === 'My Claims');
          const isSamePermission = myClaimPackage?.permissions?.find(
            x => childMenuItem?.permissionName.toLowerCase() === x.permissionName?.toLowerCase()
          );
          if (isSamePermission) {
            const claimMenu = this.menuItems.find(x => x.name === 'claim');
            return !claimMenu.permission;
          }
        }
        if (childMenuItem?.userLevelPermission?.length) {
          return this.checkUserLevelPermission(childMenuItem.userLevelPermission, automotiveServices);
        }
        return false;
      }
    }
    return false;
  }

  /**
   * check user level permissions
   * @param userPermissions
   */
  checkUserLevelPermission(userPermissions: Array<string>, automotiveService: any): boolean {
    const permissionArray = automotiveService?.permissions?.filter(x => userPermissions?.includes(x.permissionName));
    if (permissionArray?.length) {
      return true;
    }
    return false;
  }

  /**
   * check
   * @returns
   */
  checkUserLevelPermissions(userPermissions: Array<string>, automotiveServices: any): boolean {
    const permissionList = [ ...new Set(automotiveServices?.flatMap(item => item.permissions)) ];
    return permissionList?.some((x: any) => userPermissions?.includes(x.permissionName));
  }

  /**
   *
   * @param orgPackages
   * @param menuItem
   */
  getMenuPermission(orgPackages: any, automotiveServices: any, menuItem: menuItem): boolean {
    const service = orgPackages?.filter((orgPackage: any) => {
      return orgPackage.automotiveServiceName?.toLowerCase() === menuItem?.service?.toLowerCase();
    });

    if (service.length > 0) {
      if (service[0].permissions.length > 0) {
        if (service[0].automotiveServiceName === 'My Claims') {
          const claimListPackage = {
            createdDate: '0001-01-01T00:00:00Z',
            description: 'claim-list',
            permissionName: 'claim-list'
          };
          service[0].permissions.push(claimListPackage);
        }

        return this.checkUserLevelPermission(menuItem.userLevelPermission, automotiveServices);
      }
    }

    return false;
  }

  /**
   * on side menu collapse
   */
  collapseSideMenu(): void {
    this.sideMenuCollapse.emit();
  }

  /**
   * hide show ai assistance
   */
  hideShowAIAssistant(): void {
    this.showAIAssistant = !this.showAIAssistant;
    this.aiApiLoaded = true;
  }

  /**
   * Clears then restores agentAssociationId so *ngIf destroys and recreates ai-agent-assistant.
   */
  recreateAiAssistant(): void {
    const associationId = this.agentAssociationId;
    if (!associationId) {
      return;
    }
    this.agentAssociationId = '';
    this.cdr.markForCheck();
    setTimeout(() => {
      this.agentAssociationId = associationId;
      this.cdr.markForCheck();
    });
  }

  /**
   * Loads avatar and config for the default agent launcher.
   */
  getAgentDetail(): void {
    this.commonService.showLoading();
    this.aiService.getAgentDetail(this.agentAssociationId).subscribe({
      next: (res) => {
        this.commonService.hideLoading();
        const agent = res.data || {};
        if (agent?.aiAgent) {
          //agent.aiAgent.avatarUrl = 'assets/img/ai/ai-profile.png';
          this.avatarUrl = agent.aiAgent.avatarUrl || 'assets/img/ai-chat-bot-new.png';
        }
            this.cdr.markForCheck();
},
      error: () => {
        this.commonService.hideLoading();
      }
    });
  }
  /**
   * check if grand child is active
   */
  public isGrandChildActive(item: menuItem): boolean {
    return item.childMenu?.some(x => x.name === this.currentChild) ?? false;
  }
}
